var memoizedQuerySelector = function memoizedQuerySelector(selectors) {
  var element = null;
  return function () {
    if (!element) {
      element = document.querySelector(selectors);
    }
    return element;
  };
};
export var getProductReleaseVersion = function getProductReleaseVersion(product) {
  var _buildInfo;
  switch (product === null || product === void 0 ? void 0 : product.toLowerCase()) {
    case 'confluence':
      return ((_buildInfo = window.__buildInfo) === null || _buildInfo === void 0 ? void 0 : _buildInfo.FRONTEND_VERSION) || 'noversion';
    case 'jira':
      return window.BUILD_KEY;
    case 'townsquare' || 'atlas':
      var versionMeta = memoizedQuerySelector('meta[name="release-version"]');
      if (versionMeta instanceof HTMLMetaElement) {
        return versionMeta.content;
      }
  }
  return 'noversion';
};